/**
 * Pikra logo — minimal sparkle/star mark.
 * A 4-point star with a subtle glow feel,
 * simple and magical.
 */
export default function Logo({ size = 24, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Pikra"
    >
      {/* 4-point star */}
      <path
        d="M12 2 L14 9 L21 12 L14 15 L12 22 L10 15 L3 12 L10 9 Z"
        fill="currentColor"
        opacity="0.9"
      />
      {/* Small accent dot */}
      <circle cx="17" cy="6" r="1.2" fill="currentColor" opacity="0.4" />
    </svg>
  );
}
